import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import {
    deleteMediRequestForm,
    getMediRequestFormById,
    pagingMediRequestForm,
    saveMediRequestForm
} from 'app/services/MedicationRequestFormService';
import { ConceptForm } from "app/common/Model/ConceptForm";
import { checkSearchObject } from "app/common/LocalFunction";
import { toast } from "react-toastify";
import { MedicationRequestForm } from "app/common/Model/MedicationRequestForm";

export default class MedicationRequestFormStore {
    searchMediRequestForm = new SearchObject();
    pageMediRequestForm = null;
    selectedMediRequestForm = new MedicationRequestForm();
    openFormCreateOrEdit = false;
    openConfirmDeleteMediRequestForm = false;

    constructor() {
        makeAutoObservable(this);
    }


    pagingMediRequestForm = async (searchObj) => {
        let newSearchObj = {...this.searchMediRequestForm, ...searchObj}
        if(this.searchMediRequestForm?.room) {
            newSearchObj.roomId = this.searchMediRequestForm?.room?.id
        }
        if(this.searchMediRequestForm?.department) {
            newSearchObj.departmentId = this.searchMediRequestForm?.department?.id
        }
        return await pagingMediRequestForm(newSearchObj)
            .then(({ data }) => {
                this.pageMediRequestForm = data;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu có lỗi");
            })
    }

    handleChangeFormSearch = (searchMediRequestForm) => {
        this.searchMediRequestForm = checkSearchObject(this.searchMediRequestForm, searchMediRequestForm);
        this.pagingMediRequestForm();
    }

    handleOpenFormCreateOrEdit = (mediRequestFormId,) => {
        if (Boolean(mediRequestFormId)) {
            getMediRequestFormById(mediRequestFormId)
                .then(({ data }) => {
                    this.selectedMediRequestForm = data;
                    this.openFormCreateOrEdit = true;
                })
                .catch((error) => {
                    console.error(error);
                    toast.error("Lấy dữ liệu có lỗi");
                })
        } else {
            this.selectedMediRequestForm = new MedicationRequestForm();
            this.openFormCreateOrEdit = true;
        }
    }
    handleSelectedMediRequestFormInDrug = ({drugs}) => {
        this.selectedMediRequestForm = {...new MedicationRequestForm(),drugs};
        this.openFormCreateOrEdit = true;
    }

    saveMediRequestForm = async (mediRequestForm, { setSubmitting }) => {
        return await saveMediRequestForm(mediRequestForm).then(() => {
            this.selectedMediRequestForm = null;
            toast.success("Lưu mẫu đơn thuốc thành công!");
            this.handleClosePopup();
            this.pagingMediRequestForm();
        })
            .catch(error => {
                console.error(error);
                toast.error("Lưu thông tin mẫu đơn thuốc có lỗi");
            })
            .finally(() => setSubmitting(false))
    }

    handleDeletemediRequestForm = (mediRequestForm) => {
        this.selectedMediRequestForm = { id: mediRequestForm?.id };
        this.openConfirmDeleteMediRequestForm = true;
    }

    handleConfirmDeleteMediRequestForm = () => deleteMediRequestForm(this?.selectedMediRequestForm?.id)
        .then(() => {
            if (this.searchMediRequestForm.pageIndex > 1 && this.pageMediRequestForm?.content?.length === 1) {
                this.searchMediRequestForm.pageIndex -= 1;
            }
            toast.success("Xóa mẫu đơn thuốc thành công!")
            this.handleClosePopup();
            this.pagingMediRequestForm();
        })
        .catch(err => {
            console.error(err);
            toast.error("Xóa mẫu đơn thuốc có lỗi");
        })

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteMediRequestForm = false;
    }

    resetStore = () => {
        this.searchMediRequestForm = new SearchObject();
        this.pageMediRequestForm = null;
        this.selectedMediRequestForm = null;
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteMediRequestForm = false;
    }

}